import { render, staticRenderFns } from "./EditFields.vue?vue&type=template&id=76267874&scoped=true"
import script from "./EditFields.vue?vue&type=script&lang=js"
export * from "./EditFields.vue?vue&type=script&lang=js"
import style0 from "./EditFields.vue?vue&type=style&index=0&id=76267874&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76267874",
  null
  
)

export default component.exports